import { Setting, SettingDisplay } from "../Common/Settings";
import { useTranslation } from "react-i18next";

export default function FrequencySet({ value }) {
  const { t } = useTranslation(["common", "settings"]);

  return (
    <Setting>
      <SettingDisplay
        label={t("settings:items.subscription.frequency")}
        value={t(`settings:items.subscription.frequencies.${value}`)}
      />
    </Setting>
  );
}
